<template>
  <a-card :bordered='false' :bodyStyle="{paddingTop:'10px'}" :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <AccountEditorView @submit='requestSubmit' :submit-loading='submitLoading'></AccountEditorView>
    <custom-page-table
      :request-promise='getAccountPromise'
      :columns='getAccountColumns()'
      :query-params='queryAccountParams'
      ref='accountList'>
      <span slot='action' slot-scope='rowItem'>
        <a @click='onEditAccountEvent(rowItem.record)'>编辑</a>
        <a-divider type='vertical'></a-divider>
        <a @click='onUpdateStateAccountEvent(rowItem.record)'>{{ rowItem.record.state === 1 ? '禁用' : '启用' }}</a>
        <!--        <template v-if='rowItem.record.state === 1'>-->
        <!--          <a-divider type='vertical'></a-divider>-->
        <!--          <a @click='onEditRuleEvent(rowItem.record)'>同步规则</a>-->
        <!--        </template>-->
      </span>
    </custom-page-table>
    <a-modal
      v-if='showEditDialog'
      title='编辑账号'
      :visible='showEditDialog'
      @cancel='showEditDialog=false'
      :footer='null'
      width='800px'>
      <AccountEditorView
        :value='editAccountInfo'
        :show-tips='false'
        @submit='updateAccountEvent'
        submit-button-name='保存'
        :submit-loading='updateLoading'></AccountEditorView>
    </a-modal>
  </a-card>
</template>

<script>
import AccountEditorView from '@/views/service/serviceProvider/oto/view/AccountEditorView'


export default {
  name: 'LinkedAccountList',
  components: { AccountEditorView },
  props: {},
  data() {
    return {
      submitLoading: false,
      updateLoading: false,
      showEditRuleDialog: false,
      showEditDialog: false,
      queryAccountParams: {
        platformId: '',
        merchantId: ''
      },
      editAccountInfo: {}
    }
  },
  created() {
    let merchantId = this.$store.getters.userInfo.merchantId
    let platformId = this.getPlatformConfig().platformId
    this.queryAccountParams = { platformId, merchantId }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'OuTuService', title: '商品订单' },
      { name: 'LinkedAccountList', title: '关联账号' }
    ])
  },
  methods: {
    getAccountPromise(parameter) {
      return this.getHttpServices().getServerApiService().post('/oto/account/queryOtoAccountList', parameter)
    },
    getAccountColumns() {
      return [
        {
          title: '商品标题前缀',
          dataIndex: 'prefix'
        },
        {
          title: '接口域名',
          dataIndex: 'domain'
        },
        {
          title: 'APPID',
          dataIndex: 'appId'
        },
        {
          title: '平台公钥',
          dataIndex: 'publicKey'
        },
        {
          title: '状态',
          dataIndex: 'stateStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onEditAccountEvent(record) {
      const { id, publicKey, domain, prefix, appId } = record
      this.editAccountInfo = { id, publicKey, domain, prefix, appId }
      this.showEditDialog = true
    },

    onUpdateStateAccountEvent(record) {
      const params = { id: record.id, state: String(record.state) === '1' ? 0 : 1 }
      this.getHttpServices().getServerApiService()
        .post('oto/account/modifyOtoAccountInfoState', params)
        .then(res => {
          this.$refs.accountList.refresh(false)
        })
        .catch(reason => {
          console.error(reason)
          this.showNetWorkErrorMessage(reason)
        })
    },

    updateAccountEvent(info) {
      this.updateLoading = true
      this.getHttpServices().getServerApiService()
        .post('oto/account/modifyOtoAccountInfo', info)
        .then(res => {
          this.$message.success('账号编辑成功')
          this.showEditDialog = false
          this.$refs.accountList.refresh(true)
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
        .finally(() => this.updateLoading = false)
    },
    requestSubmit(formParams) {
      this.submitLoading = true
      const params = { ...formParams, ...this.queryAccountParams }
      this.getHttpServices().getServerApiService()
        .post('oto/account/addOtoAccountInfo', params)
        .then(res => {
          this.$refs.accountList.refresh(true)
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
        .finally(() => this.submitLoading = false)
    },

    onEditRuleEvent(record) {
      console.error('==onEditRuleEvent==', record)
      this.showEditRuleDialog = true
    }
  }
}
</script>

<style scoped lang='less'>

</style>
